import { render, staticRenderFns } from "./Call_Action.vue?vue&type=template&id=eca68500&scoped=true&"
import script from "./Call_Action.vue?vue&type=script&lang=js&"
export * from "./Call_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca68500",
  null
  
)

export default component.exports